import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import './CoursesGrid.css';

import cor1 from '../assets/images/cimage3.jpg';
import cor2 from '../assets/images/c++image.jpg';
import cor3 from '../assets/images/java.jpg';
import cor4 from '../assets/images/Pythonimage1.jpg';
import cor5 from '../assets/images/mysql.jpg';
import cor6 from '../assets/images/linux.jpg';
import cor7 from '../assets/images/basic-office.jpg';
import cor8 from '../assets/images/html-css-js.jpg';

const courses = [
  {
    id: 1,
    category: "Short Term Courses",
    title: "C",
    image: cor1,
    hours: "30 Hours",
    duration: "Spread Across 12 weeks",
    assessments: "10 hrs of assessment",
    projects: "Practice projects",
    // internships: "Internship opportunity upon course completion",
  },
  {
    id: 2,
    category: "Short Term Courses",
    title: "C++ Programming",
    image: cor2,
    hours: "30 Hours",
    duration: "Spread Across 12 weeks",
    assessments: "10 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 3,
    category: "Short Term Courses",
    title: "Core Java",
    image: cor3,
    hours: "30 Hours",
    duration: "Spread Across 12 weeks",
    assessments: "10 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 4,
    category: "Short Term Courses",
    title: "Python Programming",
    image: cor4,
    hours: "30 Hours",
    duration: "Spread Across 12 weeks",
    assessments: "10 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 5,
    category: "Short Term Courses",
    title: "SQL",
    image: cor5,
    hours: "30 Hours",
    duration: "Spread Across 12 weeks",
    assessments: "10 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 6,
    category: "Short Term Courses",
    title: "Linux Fundamentals",
    image: cor6,
    hours: "30 Hours",
    duration: "Spread Across 12 weeks",
    assessments: "10 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 7,
    category: "Short Term Courses",
    title: "Basic Office",
    image: cor7,
    hours: "30 Hours",
    duration: "Spread Across 12 weeks",
    assessments: "10 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 8,
    category: "Short Term Courses",
    title: "HTML / CSS / JS ",
    image: cor8,
    hours: "30 Hours",
    duration: "Spread Across 12 weeks",
    assessments: "10 hrs of assessment",
    projects: "Practice projects",
  },
];

const CourseGrid = () => {
  const navigate = useNavigate();  // Initialize useNavigate

  // Handle the apply button click
  const handleApplyClick = () => {
    window.scrollTo(0, 0); // Scroll to the top of the page
    navigate('/short-term-courses');  // Navigate to /short-term-courses route
  };

  return (
    <div className="course-grid-1">
      <h1>Short Term Courses</h1>
      <div className="courses-container-1">
        {courses.map(course => (
          <div key={course.id} className="course-card-1" id={course.id}>
            <img src={course.image} alt={course.title} className="course-image-1" />
            <h3 className="course-title-1">{course.title}</h3>
            <p className="course-category-1"><em>{course.category}</em></p>
            <p className="course-hours-1"><strong>{course.hours}</strong></p>
            <p className="course-duration-1">{course.duration}</p>
            <p className="course-assessments-1"> {course.assessments}</p>
            <p className="course-projects-1">Projects: {course.projects}</p>
            {/* <p className="course-internships-1">Internships: {course.internships}</p> */}
            {/* The Apply Now text that is clickable */}
            <p className="apply-now" onClick={handleApplyClick}>Apply Now...</p> 
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseGrid;
